/** The eight locales every MafiaGo surface ships in, in switcher order. */
export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'pt-PT', label: 'Português (PT)' },
  { code: 'pt-BR', label: 'Português (BR)' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'nl', label: 'Nederlands' },
] as const

export type LanguageCode = (typeof LANGUAGES)[number]['code']

export const LANGUAGE_CODES: readonly LanguageCode[] = LANGUAGES.map((l) => l.code)

export const NAMESPACES = ['common', 'errors', 'map'] as const

/**
 * Browser tags → a supported locale. Brazilian Portuguese is the one regional
 * split; every other `pt-*` (and bare `pt`) is European Portuguese.
 */
export function normalizeLanguage(tag: string | undefined | null): LanguageCode {
  if (!tag) return 'en'
  const lower = tag.toLowerCase()
  if (lower === 'pt-br') return 'pt-BR'
  if (lower === 'pt' || lower.startsWith('pt-')) return 'pt-PT'
  const base = lower.split('-')[0]
  const hit = LANGUAGE_CODES.find((c) => c === base)
  return hit ?? 'en'
}
